import { useState } from 'react'
import { useAsyncEffect } from 'utils'
import { MediaInfo } from '../types'
import { mediaInfoFromSource } from '../utils/media/media-info'

const useMediaInfo = (source: File | string): MediaInfo | undefined => {
    const [info, setInfo] = useState<MediaInfo | undefined>()

    useAsyncEffect(async () => {
        try {
            const mediaInfo = await mediaInfoFromSource(source)
            setInfo(mediaInfo || undefined)
        } catch (err) {
            setInfo(undefined)
        }
    }, [source])

    return info
}

export default useMediaInfo
